import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cash-movement',
  templateUrl: './cash-movement.component.html',
  styleUrls: ['./cash-movement.component.css']
})
export class CashMovementComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/cashmovements/cash-movement.component.ts